import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { CountriesActivites } from '../../interface/Back';
import { filterByActivities, filterByContinents, getAllCountries, orderByName, orderByPopulation } from '../../redux/Actions';
import { BtnHome, EvenSelect } from '../../types/Functions';
import { Cards } from '../Cards/Cards';
import { FilterOrder } from '../FilterOrder/FilterOrder';
import { Loading } from '../Loading/Loading';
import { Search } from '../Search/Search';
import { Paginado } from './Paginado';

export const Home = () => {
  const dispatch = useAppDispatch();

  let { countries } = useAppSelector(state => state);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [countriesPerPage, setCountriesPerPage] = useState<number>(9);
  const indexOfLastCountry: number = currentPage * countriesPerPage;
  const indexOfFirstCountry: number = indexOfLastCountry - countriesPerPage;
  const currentCountry: CountriesActivites[] = countries.slice(indexOfFirstCountry, indexOfLastCountry);
  const [minPageNumber, setMinPageNumber] = useState<number>(0)
  const [maxPageNumber, setMaxPageNumber] = useState<number>(5)
  const [, setOrden] = useState('');

  useEffect(() => {
    dispatch<any>(getAllCountries());
  }, [dispatch]);

  const handlerClick: BtnHome = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    dispatch<any>(getAllCountries());
  };

  const OrderName: EvenSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //* FUNCIONA
    e.preventDefault();
    dispatch<any>(orderByName(e.target.value));
    setCurrentPage(1);
    setOrden(e.target.value);
  };

  const OrderPopulation: EvenSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //* FUNCIONA
    e.preventDefault();
    dispatch<any>(orderByPopulation(e.target.value));
    setCurrentPage(1);
    setOrden(e.target.value);
  };

  const FilterContinent: EvenSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //* FUNCIONA
    e.preventDefault();
    dispatch<any>(filterByContinents(e.target.value));
    setCurrentPage(1);
    setOrden(e.target.value);
  };

  const FilterActivity: EvenSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //* FUNCIONA
    e.preventDefault();
    dispatch<any>(filterByActivities(e.target.value));
    setCurrentPage(1);
    setOrden(e.target.value);
  };

  return (
    <div className='home__container' >
      <h1>PI COUNTRIES</h1>
      <div className='home__container__buttons' >
        <Link to={'/create-activity'} >
          <button className='home__container__buttons__btn--create'>
            Crear Actividad
          </button>
        </Link>

        <Link to={'/activities'} >
          <button className='home__container__buttons__btn'>
            Actividades
          </button>
        </Link>

        <div>
          <button
            onClick={(e) => handlerClick(e)}
            className='home__container__buttons__btn--loading'
          >
            Cargar todos los paises
          </button>
        </div>
      </div>
      <div>
        <Search />
      </div>
      <div>
        <FilterOrder
          OrderName={OrderName}
          OrderPopulation={OrderPopulation}
          FilterContinent={FilterContinent}
          FilterActivity={FilterActivity}
        />
      </div>
      <div>
        <Paginado
          countries={countries}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setCountriesPerPage={setCountriesPerPage}
          minPageNumber={minPageNumber}
          setMinPageNumber={setMinPageNumber}
          maxPageNumber={maxPageNumber}
          setMaxPageNumber={setMaxPageNumber}
        />
      </div>
      <div className='home__container__cards' >
        {
          !currentCountry.length ? (
            <div>
              <h1>La información saldrá en un momento, espere por favor...</h1>
              <Loading />
            </div>
          ) : (
            currentCountry.map((el: CountriesActivites) => {
              return (
                <div key={el.cca3} >
                  <Cards
                    key={el.cca3}
                    cca3={el.cca3}
                    name={el.name}
                    flags={el.flags}
                    continents={el.continents}
                    capital={el.capital}
                    population={el.population}
                    activities={el.activities}
                  />
                </div>
              );
            })
          )
        }
      </div>
    </div>
  );
}
